import { useMemo } from 'react'

import { VideosTableCellLazy } from 'components/VideosTableCell'
import { useTranslate } from 'lib/tolgee'
import { TOLGEE_GLOBALS } from 'utils'

import {
  FavoriteTableCell,
  FormatCreateByTableCell,
  FormatTitleTableCell,
  FormatUploadDateTableCell,
  FormatZaiTableCell,
} from '../owned-topics-table-cells'
import { translations } from './owned-topics-table.i18n'
import type { IOwnedTopicsTable } from './owned-topics-table.types'

export const useOwnedTopicsTableModel = (): IOwnedTopicsTable => {
  const t = useTranslate()

  const headers = useMemo(
    () => [
      {
        label: '',
        key: 'favorite',
        component: FavoriteTableCell,
        isSortable: false,
      },
      {
        label: t(TOLGEE_GLOBALS.topics),
        key: 'topic',
        isTitle: true,
        component: FormatTitleTableCell,
      },
      {
        label: t(TOLGEE_GLOBALS.createdBy),
        key: 'createdBy',
        component: FormatCreateByTableCell,
        isSortable: false,
        isTitle: true,
      },
      {
        label: t(TOLGEE_GLOBALS.uploadDate),
        key: 'uploadDate',
        component: FormatUploadDateTableCell,
        isSortable: false,
        tooltipMessage: t(translations.uploadDateTooltip),
        isTitle: true,
        icon: 'questionMark',
      },
      {
        label: t(TOLGEE_GLOBALS.videos),
        key: 'videos',
        component: VideosTableCellLazy,
        isSortable: false,
      },
      {
        label: '',
        key: 'zai',
        component: FormatZaiTableCell,
        isSortable: false,
      },
    ],
    [t]
  )

  return { headers }
}
